<template>
  <div class="login-page">
    <!-- 左侧：科技风品牌区 -->
    <div class="brand-panel">
      <div class="brand-bg">
        <div class="grid-lines"></div>
        <div class="glow glow-1"></div>
        <div class="glow glow-2"></div>
        <div class="glow glow-3"></div>
      </div>

      <div class="brand-content">
        <div class="brand-logo">
          <div class="logo-mark"><i class="el-icon-guide"></i></div>
          <span class="logo-name">访客综合管理平台</span>
        </div>

        <h1 class="brand-title">智慧访客通行<br/><span>一站式数字化管理</span></h1>
        <p class="brand-desc">预约 · 审批 · 签到 · 门禁 · 统计，覆盖访客全流程生命周期</p>

        <div class="brand-stats">
          <div class="stat-item">
            <div class="stat-value">SaaS</div>
            <div class="stat-label">多租户架构</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <div class="stat-value">全流程</div>
            <div class="stat-label">访客生命周期</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <div class="stat-value">多端</div>
            <div class="stat-label">PC / H5 / 终端</div>
          </div>
        </div>
      </div>

      <div class="brand-footer">Visitor Management System · Enterprise Edition</div>
    </div>

    <!-- 右侧：登录表单区 -->
    <div class="form-panel">
      <div class="form-card">
        <h2 class="form-title">欢迎登录</h2>
        <p class="form-subtitle">请输入您的账号信息</p>

        <div class="seg-tabs">
          <div class="seg-item" :class="{ active: activeName === 'employee' }"
               @click="activeName = 'employee'">员工账号</div>
          <div class="seg-item" :class="{ active: activeName === 'manage' }"
               @click="activeName = 'manage'">其它账号</div>
        </div>

        <el-input class="lg-input" v-model="form.tenantCode" placeholder="租户编码"
                  prefix-icon="el-icon-office-building"></el-input>
        <el-input class="lg-input" v-model="form.name" placeholder="账号"
                  prefix-icon="el-icon-user"></el-input>
        <el-input class="lg-input" v-model="form.password" type="password" placeholder="密码"
                  prefix-icon="el-icon-lock" show-password></el-input>

        <div class="verify-row">
          <el-input class="lg-input verify-input" v-model="verifyValue" placeholder="验证码"
                    prefix-icon="el-icon-key"></el-input>
          <div class="verify-code" title="点击刷新" @click="refreshVerifyCode">
            <span>{{ verifyCode }}</span>
          </div>
        </div>

        <button class="submit-btn" type="button" @click="doBeforeSubmit()">
          <span>登 录</span>
          <i class="el-icon-right"></i>
        </button>

        <div class="form-footer">
          <span class="version-tag">V2.5.4</span>
        </div>
      </div>
    </div>

    <el-dialog class="myDialog" title="修改密码" :visible.sync="passwordDialogShow" width="600px">

      <el-form :model="passwordForm" label-width="80px">
        <el-form-item required label="原始密码">
          <el-input style="" v-model="passwordForm.oldPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item required label="新密码">
          <el-input v-model="passwordForm.newPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item required label="重新输入">
          <el-input v-model="passwordForm.confirmPassword" type="password"></el-input>
        </el-form-item>
        <br><br><br>
        <el-form-item>
          <el-button type="primary" @click="fixPassword">确认修改</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>




  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import {accountLogin, accountUpdate} from '@/api/account-api'
import {employeeLogin, employeeUpdate} from '@/api/mobile/mobile-employee-api'
import {getRoleById} from "@/api/role-api";
import {getTenantCode, setTenantCode} from "@/api/config/http-configs";

export default {
  name: 'MyLogin',

  mounted() {
    this.refreshVerifyCode();
    // 预填上次的租户编码
    this.form.tenantCode = getTenantCode();
    // SSO 免登（总后台「登录租户后台」跳转）：/#/login?sso=<urlencode(json)>
    const sso = this.$route && this.$route.query ? this.$route.query.sso : "";
    if (sso) {
      this.handleSsoLogin(String(sso));
    }
  },

  data() {
    return {
      activeName: 'employee',
      form: {
        tenantCode: '',
        name: '',
        password: ''
      },

      verifyCode: "",
      verifyValue: null,
      verifyAnswer: 0, // 数学表达式正确答案


      passwordDialogShow: false,

      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },

      currentLoginInfo: null,


    }

  },

  methods: {
    ...mapMutations(['setLoginData', 'setEmployeeLoginData', 'setRoleData', "setToken", 'setPasswd', 'doOnLogout']),

    // 总后台「登录租户后台」免登进入：payload = {tenantCode, manage(登录接口返回的账号数据, 含 token)}
    handleSsoLogin(raw) {
      // 先清掉地址栏免登参数，避免 token 停留在浏览器地址栏/历史
      this.$router.replace({name: 'login'}).catch(err => {
        console.log("err =>", err)
      })

      let payload = null;
      try {
        payload = JSON.parse(raw);
      } catch (e) {
        try {
          payload = JSON.parse(decodeURIComponent(raw));
        } catch (e2) {
          payload = null;
        }
      }
      const manage = payload && payload.manage;
      if (!payload || !payload.tenantCode || !manage || !manage.token || !manage.roleType) {
        this.$message.error('免登参数无效，请从总后台重新进入');
        return;
      }

      setTenantCode(payload.tenantCode);
      this.doOnLogout();
      this.setToken(manage.token);

      const enter = () => {
        this.setLoginData(manage);
        if (manage.roleType === 'GUARD') {
          this.$router.push({path: "/guard"}).catch(err => {
            console.log("err =>", err)
          });
        } else {
          this.$router.push({name: "subscribe"}).catch(err => {
            console.log("err =>", err)
          });
        }
        this.$message.success('已进入租户后台');
      };

      if (manage.roleType === 'COMMON') {
        // 自定义角色需先取角色权限（与正常登录流程一致）
        getRoleById(manage.roleValue).then(({data}) => {
          if (data.code === 200) {
            this.setRoleData(data.data);
            enter();
          } else {
            this.$message.error('免登失败，权限获取失败');
          }
        }).catch((error) => {
          console.log("sso getRoleById error =>", error)
          this.$message.error('免登失败，请稍后重试');
        });
      } else {
        enter();
      }
    },

    fixPassword() {
      if (this.passwordForm.oldPassword !== this.form.password) {
        this.$message.error('原始密码不正确');
        return;
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        this.$message.error('两次输入的密码不一致');
        return;
      }

      if (this.passwordForm.newPassword === this.passwordForm.oldPassword) {
        this.$message.error('新密码不能与原始密码相同');
        return;
      }

      // 密码大写，小写，数字，特殊符合，四选三，长度8位-16位


      if (this.passwordForm.newPassword.length < 8 || this.passwordForm.newPassword.length > 16) {
        this.$message.error('密码长度需要设置为8位-16位');
        return;
      }

      let passCount = 0;
      let hasUpper = false;
      let hasLower = false;
      let hasNumber = false;
      let hasSpecial = false;
      const specialChars = "!@#$%^&*()_+{}|:<>?~`-=[];',./";
      for (let i = 0; i < this.passwordForm.newPassword.length; i++) {
        const char = this.passwordForm.newPassword.charAt(i);
        if (char >= 'A' && char <= 'Z') {
          hasUpper = true;
        } else if (char >= 'a' && char <= 'z') {
          hasLower = true;
        } else if (char >= '0' && char <= '9') {
          hasNumber = true;
        } else if (specialChars.indexOf(char) >= 0) {
          hasSpecial = true;
        }
      }
      if (hasUpper) {
        passCount++;
      }
      if (hasLower) {
        passCount++;
      }
      if (hasNumber) {
        passCount++;
      }
      if (hasSpecial) {
        passCount++;
      }
      if (passCount < 3) {
        this.$message.error('密码需要包含大写字母，小写字母，数字，特殊符号中的三种');
        return;
      }

      if (this.activeName === 'manage') {
        this.fixManagePassword()
      } else {
        this.fixEmployeePassword()
      }
    },



    doOnLoginSuccess(loginData) {
      // 后端异常场景可能返回 200+空数据，判空兜底防 TypeError 卡死无提示
      if (!loginData || !loginData.token) {
        this.$message.error('账号或密码错误');
        return;
      }
      this.currentLoginInfo = loginData;

      this.setToken(loginData.token)

      if (loginData.defaultPassword === this.form.password) {
        // 默认密码， 需要强制修改密码
        this.passwordDialogShow = true;
        return;
      }


      if (loginData.roleType === "COMMON") {
        const roleValue = loginData.roleValue;
        getRoleById(roleValue).then(({data}) => {

          if (data.code === 200) {
            this.doOnLogout()
            this.setRoleData(data.data)
            this.doAfterLoginSuccess(loginData)
          } else {
            this.$message.error('登陆失败，权限获取失败');
          }
        }).catch((error) => {
          console.log("getRoleById error =>", error)
          this.showNetErrMsg()
        })

      } else {
        this.doOnLogout()
        this.doAfterLoginSuccess(loginData)
      }
    },

    doAfterLoginSuccess(loginData) {
      if (this.activeName === "manage") {
        this.setLoginData(loginData);
      } else {
        this.setEmployeeLoginData(loginData);
      }
      this.setPasswd(this.form.password)
      // this.$router.push({name: "subscribe"}).catch(err => {
      //   console.log("err =>", err)  // 重复点击路由报错
      // });
      this.doJumpAfterLogin(loginData)

      this.$message.success('登录成功');
    },

    doJumpAfterLogin(loginData) {
      if (this.activeName === "manage" && loginData.roleType === "GUARD") {
        this.$router.push({path: "/guard"}).catch(err => {
          console.log("err =>", err)  // 重复点击路由报错
        });
      } else if (this.$store.state.accountType === "employee") {
        this.$router.push({path: "/work"}).catch(err => {
          console.log("err =>", err)  // 重复点击路由报错
        });
      } else {
        this.$router.push({name: "subscribe"}).catch(err => {
          console.log("err =>", err)  // 重复点击路由报错
        });
      }
    },

    doManageLogin() {
      accountLogin(this.form.name, this.form.password).then(({data}) => {
            if (data.code === 200) {
              this.doOnLoginSuccess(data.data)
            } else {
              this.$message.error(data.msg || '登陆失败，账号或密码错误')
            }
          }
      ).catch(error => {
        console.log("error =>", error)
        this.$message.error((error && error.msg) || '登录失败，请检查租户编码或网络')
      })
    },

    doEmployeeLogin() {
      console.log("doEmployeeLogin")
      employeeLogin(this.form.name, this.form.password).then(({data}) => {
            console.log("login data =>", data)
            if (data.code === 200) {
              this.doOnLoginSuccess(data.data)
            } else {
              this.$message.error(data.msg || '登陆失败，账号或密码错误')
            }
          }
      ).catch((error) => {
        console.log("error =>", error)
        this.$message.error((error && error.msg) || '登录失败，请检查租户编码或网络')
      })
    },

    doBeforeSubmit() {
      const tenantCode = (this.form.tenantCode || '').trim()
      if (!tenantCode) {
        this.$message.error('请输入租户编码')
        return
      }
      // 先落存再发请求：axios 拦截器会为后续所有请求携带 X-Tenant-Code 请求头，
      // 后端 TenantMW 校验租户有效性（不存在/停用/到期返回 401）
      setTenantCode(tenantCode)

      this.submit()
    },



    submit() {
      if (String(this.verifyAnswer) !== String(this.verifyValue)) {
        this.$message.error('验证码错误');
        this.refreshVerifyCode();
        return;
      }

      if ((this.form.name === "") && (this.form.password === "")) {
        this.$message.error('请输入账号和密码');
        return;
      }
      if (this.activeName === "employee") {
        this.doEmployeeLogin()
      } else {
        this.doManageLogin()
      }
    },

    refreshVerifyCode() {
      let codeObj = this.generateMathVerifyCode();
      this.verifyCode = codeObj.expression;
      this.verifyAnswer = codeObj.answer;
      this.verifyValue = "";
    },

    generateMathVerifyCode() {
      // 生成 4 位纯数字验证码
      let code = Math.floor(Math.random() * 9000) + 1000; // 1000-9999
      return {expression: String(code), answer: String(code)};
    },

    fixManagePassword() {
      let postData = {
        id: this.currentLoginInfo.id,
        password: this.passwordForm.newPassword
      }
      console.log("fixManagePassword =>", postData)
      accountUpdate(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success('修改成功');
          this.passwordDialogShow = false;
          this.doReLogin()
        } else {
          this.$message.error('修改失败');
        }
      }).catch((error) => {
        console.log("error =>", error)
        this.showNetErrMsg()
      })

    },

    doReLogin() {

      this.setLoginData({});
      this.setEmployeeLoginData({});
      this.form = {
        name: '',
        password: ''
      }
      this.verifyValue = ""
      this.currentLoginInfo = null;
    },

    fixEmployeePassword() {
      let postData = {
        id: this.currentLoginInfo.id,
        loginPassword: this.passwordForm.newPassword
      }
      console.log("fixEmployeePassword postData =>", postData)
      employeeUpdate(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success('修改成功');
          this.passwordDialogShow = false;
          this.doReLogin()
        } else {
          this.$message.error('修改失败');
          console.log("fixEmployeePassword error =>", data)
        }
      }).catch((error) => {
        console.log("error =>", error)
        this.showNetErrMsg()
      })
    },
  }
  ,
}
</script>

<style lang="less" scoped>
@brand-1: #2563eb;
@brand-2: #4f46e5;
@ink: #111827;
@ink-2: #6b7280;

.login-page {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
}

/* ================= 左侧品牌区 ================= */
.brand-panel {
  position: relative;
  flex: 1.25;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 64px 80px 40px;
  color: #fff;
  background: linear-gradient(135deg, #080f22 0%, #0b1739 45%, #101f52 100%);
  overflow: hidden;
}

.brand-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.grid-lines {
  position: absolute;
  inset: -50%;
  background-image: linear-gradient(rgba(148, 163, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 255, 0.05) 1px, transparent 1px);
  background-size: 52px 52px;
  transform: perspective(500px) rotateX(30deg);
  animation: grid-move 24s linear infinite;
}

@keyframes grid-move {
  from { background-position: 0 0; }
  to { background-position: 0 520px; }
}

.glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.45;
}

.glow-1 {
  width: 480px;
  height: 480px;
  top: -120px;
  right: -80px;
  background: radial-gradient(circle, rgba(37, 99, 235, 0.55), transparent 70%);
  animation: float-1 9s ease-in-out infinite;
}

.glow-2 {
  width: 420px;
  height: 420px;
  bottom: -100px;
  left: -60px;
  background: radial-gradient(circle, rgba(79, 70, 229, 0.5), transparent 70%);
  animation: float-2 11s ease-in-out infinite;
}

.glow-3 {
  width: 260px;
  height: 260px;
  top: 40%;
  left: 55%;
  background: radial-gradient(circle, rgba(34, 211, 238, 0.3), transparent 70%);
  animation: float-1 13s ease-in-out infinite reverse;
}

@keyframes float-1 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-30px, 26px); }
}

@keyframes float-2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(26px, -22px); }
}

.brand-content {
  position: relative;
  z-index: 1;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 72px;

  .logo-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    font-size: 22px;
    color: #fff;
    background: linear-gradient(135deg, @brand-1, @brand-2);
    box-shadow: 0 6px 24px rgba(37, 99, 235, 0.45);
  }

  .logo-name {
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 1px;
  }
}

.brand-title {
  font-size: 42px;
  font-weight: 700;
  line-height: 1.28;
  letter-spacing: 1px;
  margin: 0 0 20px;

  span {
    background: linear-gradient(90deg, #7dd3fc, #a5b4fc);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.brand-desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 0.5px;
  margin: 0 0 64px;
}

.brand-stats {
  display: flex;
  align-items: center;

  .stat-item {
    padding: 0 36px;

    &:first-child { padding-left: 0; }

    .stat-value {
      font-size: 22px;
      font-weight: 700;
      letter-spacing: 1px;
      background: linear-gradient(90deg, #93c5fd, #c7d2fe);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .stat-label {
      margin-top: 6px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.45);
      letter-spacing: 1px;
    }
  }

  .stat-divider {
    width: 1px;
    height: 34px;
    background: rgba(255, 255, 255, 0.14);
  }
}

.brand-footer {
  position: absolute;
  left: 80px;
  bottom: 28px;
  font-size: 12px;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.28);
}

/* ================= 右侧表单区 ================= */
.form-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fc;
}

.form-card {
  width: 380px;
  padding: 0 8px;
}

.form-title {
  font-size: 26px;
  font-weight: 700;
  color: @ink;
  margin: 0;
}

.form-subtitle {
  font-size: 13px;
  color: @ink-2;
  margin: 10px 0 30px;
}

.seg-tabs {
  display: flex;
  padding: 4px;
  margin-bottom: 26px;
  background: #eceff5;
  border-radius: 10px;

  .seg-item {
    flex: 1;
    padding: 9px 0;
    text-align: center;
    font-size: 14px;
    color: @ink-2;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.25s ease;
    user-select: none;

    &:hover { color: @ink; }

    &.active {
      color: #1e2a5a;
      font-weight: 600;
      background: #fff;
      box-shadow: 0 2px 8px rgba(30, 42, 90, 0.12);
    }
  }
}

.lg-input {
  margin-bottom: 18px;

  /deep/ .el-input__inner {
    height: 46px;
    line-height: 46px;
    border-radius: 10px;
    border: 1px solid #e3e8f0;
    background: #fff;
    font-size: 14px;
    transition: all 0.2s ease;

    &:hover { border-color: #c9d4e8; }

    &:focus {
      border-color: @brand-1;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
    }
  }

  /deep/ .el-input__prefix {
    left: 8px;
    color: #9aa4b8;
  }

  /deep/ .el-input__inner {
    padding-left: 34px;
  }
}

.verify-row {
  display: flex;
  gap: 12px;

  .verify-input { flex: 1; }
}

.verify-code {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 128px;
  height: 46px;
  margin-bottom: 18px;
  border-radius: 10px;
  cursor: pointer;
  user-select: none;
  background: linear-gradient(135deg, #eef2ff 0%, #e0e9ff 60%, #dbeafe 100%);
  border: 1px solid #dbe3f5;
  overflow: hidden;
  position: relative;

  span {
    font-family: "SF Mono", Menlo, Consolas, monospace;
    font-size: 19px;
    font-weight: 700;
    font-style: italic;
    letter-spacing: 7px;
    color: #33415c;
    transform: skewX(-6deg);
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: repeating-linear-gradient(
      -35deg,
      transparent 0,
      transparent 6px,
      rgba(99, 117, 160, 0.08) 6px,
      rgba(99, 117, 160, 0.08) 7px
    );
  }

  &:hover { filter: brightness(0.98); }
  &:active { transform: scale(0.98); }
}

.submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  margin-top: 8px;
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 6px;
  cursor: pointer;
  background: linear-gradient(90deg, @brand-1 0%, @brand-2 100%);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.35);
  transition: all 0.2s ease;

  i {
    font-size: 16px;
    letter-spacing: 0;
    transition: transform 0.2s ease;
  }

  &:hover {
    box-shadow: 0 10px 28px rgba(37, 99, 235, 0.45);
    transform: translateY(-1px);

    i { transform: translateX(3px); }
  }

  &:active { transform: translateY(0) scale(0.99); }
}

.form-footer {
  display: flex;
  justify-content: center;
  margin-top: 26px;

  .version-tag {
    padding: 3px 10px;
    font-size: 11px;
    letter-spacing: 1px;
    color: #9aa4b8;
    border: 1px solid #e3e8f0;
    border-radius: 999px;
    background: #fff;
  }
}

/* ================= 窄屏适配 ================= */
@media (max-width: 960px) {
  .brand-panel { display: none; }
  .form-panel { flex: 1; }
}

.myDialog {
  .my-input {
    margin-bottom: 20px;
    width: 300px;
    height: 50px;
  }
}
</style>
